import { reloadProfilePage } from './helper';
import {
  checkForNameValidation,
  formatZipCode,
  loginNavigatePage
} from './utility';

$(document).on('click', '.checkout_section_reload', reloadProfilePage);
$(document).on('keypress', '.checkForNameValid', checkForNameValidation);
$(document).on('keypress keyup', '.zip', formatZipCode);
$(document).ready(loginNavigatePage);
